import React, { Component } from 'react';
import TextFieldDeprecated from 'material-ui-deprecated/TextField';
import TextFieldOld from 'material-ui/TextField';
import MuiThemeProvider from 'material-ui-deprecated/styles/MuiThemeProvider';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';
import proTheme from '../ProTheme.js.jsx';
import { parseGoogleAddress, US_AND_CANADA } from './GoogleAutoCompleteHelper.js';
import { googleRef } from 'external-libs/googleMaps';

export default class HCGoogleMapsAutoComplete extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const input = document.getElementById(this.props.id);
    const options = {
      types: ['address'],
      fields: ['place_id', 'address_components', 'geometry', 'formatted_address'],
    };

    // TODO: This is temporary solution to mute sentry error, ideally will be if we'll have some
    // Provider or method which will handle checking this. More details in ticket https://housecall.atlassian.net/browse/FW-545
    const googleAutocomplete = googleRef.maps && new googleRef.maps.places.Autocomplete(input, options);

    if (googleAutocomplete) {
      googleAutocomplete.addListener('place_changed', () => {
        const selected_place = googleAutocomplete.getPlace();
        this.placeSelected(selected_place);
      });
      input.setAttribute('placeholder', '');

      googleAutocomplete.setComponentRestrictions({
        country: US_AND_CANADA,
      });
    }
  }

  placeSelected(selectedPlace) {
    const callbackObject = parseGoogleAddress(selectedPlace);
    this.props.onAutoComplete(callbackObject);
  }

  buildDeprecatedMaterialUIBody() {
    return (
      <MuiThemeProvider muiTheme={proTheme}>
        <TextFieldDeprecated
          autoFocus={this.props.autoFocus}
          name={this.props.name}
          id={this.props.id}
          floatingLabelText={this.props.floatingLabelText}
          hintText="Enter a location"
          fullWidth={true}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          value={this.props.value}
          onChange={(event, value) => {
            this.props.onTextFieldChange(event, value);
          }}
          disabled={this.props.disabled}
        />
      </MuiThemeProvider>
    );
  }

  buildOldMaterialUIBody() {
    return (
      <TextFieldOld
        autoFocus={this.props.autoFocus}
        name={this.props.name}
        id={this.props.id}
        label={this.props.floatingLabelText}
        placeholder="Enter a location"
        fullWidth={true}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        value={this.props.value}
        onChange={(event) => {
          this.props.onTextFieldChange(event, event.target.value);
        }}
        error={this.props.error}
        disabled={this.props.disabled}
        onKeyDown={(event) => {
          if (event.keyCode === 13) {
            event.preventDefault();
          }
        }}
      />
    );
  }

  buildMaterialUIBody() {
    return (
      <TextField
        variant={this.props.variant || 'filled'}
        autoFocus={this.props.autoFocus}
        name={this.props.name}
        id={this.props.id}
        label={this.props.floatingLabelText}
        placeholder="Enter a location"
        fullWidth={true}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        value={this.props.value}
        onChange={(event) => {
          this.props.onTextFieldChange(event, event.target.value);
        }}
        error={this.props.error}
        disabled={this.props.disabled}
        onKeyDown={(event) => {
          if (event.keyCode === 13) {
            event.preventDefault();
          }
        }}
        InputProps={{
          endAdornment: this.props.endAdornment,
        }}
        helperText={this.props.helperText}
        required={this.props.required}
      ></TextField>
    );
  }

  render() {
    if (this.props.useLatestMaterialUI) {
      return this.buildMaterialUIBody();
    } else if (this.props.newMaterialUI) {
      return this.buildOldMaterialUIBody();
    } else {
      return this.buildDeprecatedMaterialUIBody();
    }
  }
}

HCGoogleMapsAutoComplete.defaultProps = {
  useLatestMaterialUI: false,
};
